export const CIRCUIT_CAPACITY_BUCKETS = [
    { max: 2000, label: '0 – 2 MW', color: '#FF6347' },
    { max: 4000, label: '2 – 4 MW', color: '#FFA500' },
    { max: 6000, label: '4 – 6 MW', color: '#FFFF00' },
    { max: Infinity, label: '> 6 MW', color: '#006400' }
];

export const getCircuitColorHex = (capacityValue = 0) => {
    const numeric = Number(capacityValue);
    const safeValue = Number.isFinite(numeric) ? numeric : 0;
    const bucket = CIRCUIT_CAPACITY_BUCKETS.find((entry) => safeValue < entry.max)
        || CIRCUIT_CAPACITY_BUCKETS[CIRCUIT_CAPACITY_BUCKETS.length - 1];
    return bucket.color;
};

export const parseLadwpCapacityValue = (properties = {}) => {
    const numericSources = [
        properties.capacity_kw,
        properties.capacity_min_kw,
        properties.capacity_max_kw,
        properties.capacity
    ];

    for (const numericSource of numericSources) {
        const numericValue = Number(numericSource);
        if (Number.isFinite(numericValue) && numericValue > 0) {
            return numericValue;
        }
    }

    const rangeSource =
        properties.capacity_range_kw ||
        properties.capacity_kw_range ||
        properties.capacity_status ||
        '';

    if (typeof rangeSource === 'number') {
        return rangeSource;
    }

    if (typeof rangeSource === 'string') {
        const numericMatches = rangeSource.match(/(\d+(?:,\d+)?(?:\.\d+)?)/g);
        if (numericMatches && numericMatches.length > 0) {
            const value = Number(numericMatches[0].replace(/,/g, ''));
            if (Number.isFinite(value)) {
                return value;
            }
        }

        const normalized = rangeSource.toLowerCase();
        if (normalized.includes('high')) {
            return 4000;
        }
        if (normalized.includes('low')) {
            return 1500;
        }
        if (normalized.includes('no')) {
            return 0;
        }
    }

    return 0;
};

